import PropTypes from "prop-types";
import RadioButton from "@shared/v2/RadioButton";
import Dropdown from "@shared/v2/Dropdown";
import CircleInfoSolidV6 from "@shared/v2/Icomoon/Icons/CircleInfoSolidV6";
import Tooltip from "@shared/v2/Tooltip/Tooltip";
import { CustomControl, CustomSingleValue } from "./CustomDropdownComponents";

const BUTTON_OPTIONS = [
  { label: "Most Recent", value: "most_recent" },
  { label: "Most Views", value: "most_views" },
  { label: "Oldest", value: "oldest" },
];

const PropertyFilters = ({
  isFavorited,
  toggleButtons,
  allViewCount,
  favoriteCount,
  sortBy,
  handleSelectSortBy,
}) => (
  <div className="tw-flex tw-items-center tw-gap-[36px]">
    <Dropdown
      components={{ Control: CustomControl, SingleValue: CustomSingleValue }}
      value={BUTTON_OPTIONS.find((o) => o.value === sortBy)}
      options={BUTTON_OPTIONS}
      onChange={handleSelectSortBy}
      menuShouldComeToFront
      containerClassName="tw-min-w-[135px]"
    />
    <RadioButton
      checked={!isFavorited}
      onChange={() => toggleButtons()}
      label={`Unique Properties Viewed (${allViewCount})`}
    />
    <RadioButton
      checked={isFavorited}
      onChange={() => toggleButtons()}
      label={
        <div className="tw-flex tw-items-center tw-gap-[8px]">
          <div>Saved Listings ({favoriteCount})</div>
          <Tooltip
            placement="top"
            innerClassName="tw-max-w-[180px]"
            trigger={<CircleInfoSolidV6 className="tw-mt-[6px]" />}
            content={<div className="tw-text-left">Properties saved to this contact&apos;s Collections</div>}
          />
        </div>
      }
    />
  </div>
);

PropertyFilters.propTypes = {
  isFavorited: PropTypes.bool.isRequired,
  toggleButtons: PropTypes.func.isRequired,
  allViewCount: PropTypes.number.isRequired,
  favoriteCount: PropTypes.number.isRequired,
  sortBy: PropTypes.string.isRequired,
  handleSelectSortBy: PropTypes.func.isRequired,
};

export default PropertyFilters;
